import { SideBar } from '../../models/sideBar';
import { assetsConst } from './assets.const';
import { ModuleConst } from './moduleConst';

export const SideBarConst: Array<SideBar> = [
  {
    text: 'SIDEBARTEXT.DASHBOARD',
    path: '/dashboard',
    icon: assetsConst.dashBoardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard
  },
  {
    text: 'SIDEBARTEXT.inventory',
    path: '/products',
    isSubMenu: true,
    icon: assetsConst.ProductIcon,
    sideBarId: ModuleConst.Inventory,
    subMenuItems: [
      {
        text: 'SIDEBARTEXT.list',
        path: '/products/list/1',
        icon: assetsConst.orderIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.list
      },
      {
        text: 'SIDEBARTEXT.request',
        path: '/products/inventory-request/1',
        icon: assetsConst.returnIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.request
      },
      {
        text: 'SIDEBARTEXT.reassignFind',
        path: '/products/inventory-reassign',
        icon: assetsConst.returnIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.reassign
      }
    ]
  },
  {
    text: 'SIDEBARTEXT.orderManagement',
    path: '',
    icon: assetsConst.manageorderIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.OrderManagement,
    subMenuItems: [
      {
        text: 'SIDEBARTEXT.orders',
        path: '/manage-order',
        icon: assetsConst.orderIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.Orders,
      },
      {
        text: 'SIDEBARTEXT.manageReturn',
        path: '/manage-return',
        icon: assetsConst.returnIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.Returns
      }
    ]
  },
  {
    text: 'SIDEBARTEXT.managePayout',
    path: '/manage-payout',
    icon: assetsConst.payloutIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.ManagePayout
  },
  {
    text: 'SIDEBARTEXT.manageDriverWallet',
    path: '/manage-driver-wallet',
    icon: assetsConst.reportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.ManageDriverWallet
  },
  {
    text: 'SIDEBARTEXT.reportManagement',
    path: '/report-management/my-report/1',
    icon: assetsConst.reportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.ReportManagement
  },
  // {
  //   text: 'SIDEBARTEXT.manageReturn',
  //   path: '/manage-return',
  //   icon: assetsConst.reportIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Return
  // },
  {
    text: 'SIDEBARTEXT.rackManagement',
    path: '/rack-management',
    icon: assetsConst.RackIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.RackManagement
  },

  // {
  //   text: 'Manage Batch',
  //   path: '/manage-batch',
  //   icon: assetsConst.batchIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Return
  // },
  // {
  //   text: 'Manage Reception Area',
  //   path: '/manage-receiptionarea',
  //   icon: assetsConst.receptionIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Return
  // },
  {
    text: 'SIDEBARTEXT.SubAdmin',
    path: '/subadmin',
    icon: assetsConst.reportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SubAdmin
  },
  // {
  //   text: 'SIDEBARTEXT.SETTING',
  //   path: '/setting',
  //   icon: assetsConst.cmsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Settings
  // }
];
